import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/payments',
    name: 'payments',
    component: () => import('@/views/pages/payments/Payments.vue'),
    meta: {
      pageTitle: 'Payments',
      breadcrumb: {
        label: 'Payments'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN],
      verticalMenu: {
        title: 'Payments',
        icon: 'DollarSignIcon'
      }
    }
  },
  {
    path: '/payments/:paymentIntentId/pay-with-credit-card',
    name: 'pay_with_credit_card',
    component: () => import('@/views/pages/payments/PayWithCreditCard.vue'),
    meta: {
      pageTitle: 'Pay With Credit Card',
      breadcrumb: {
        label: 'Pay With Credit Card',
        parent: 'payments'
      }
    }
  },
  {
    path: '/payment/success',
    name: 'payment_success',
    component: () => import('@/views/pages/payments/PaymentSuccess.vue'),
    meta: {
      layout: 'full',
      resource: 'Payment',
      loggedInNotRequired: true
    }
  },
  {
    path: '/payment/error',
    name: 'payment_error',
    component: () => import('@/views/pages/payments/PaymentError.vue'),
    meta: {
      layout: 'full',
      resource: 'Payment',
      loggedInNotRequired: true
    }
  }
];
